export const getFileName = (path) => {
  // パスからファイル名を取得（最後のスラッシュの右側）

  // スラッシュがない場合はそのまま返す
  if (path.indexOf("/") === -1) return path;

  // スラッシュがある場合は最後のスラッシュの右側を返す
  return path.split("/").pop();
};



// WEBPACK FOOTER //
// ./src/recruit/js/getFileName.js